module.exports = __webpack_public_path__ + "static/media/logo.9f01297b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 543
// module chunks = 0